import { render, staticRenderFns } from "./ProjectCombobox.vue?vue&type=template&id=01d8aadb&"
import script from "./ProjectCombobox.vue?vue&type=script&lang=js&"
export * from "./ProjectCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports